import { defineMessages } from 'react-intl';

export default defineMessages({
  acimaLogoAlt: {
    id: 'AcimaButton.acimaLogo.alt',
    description: 'Alternative text to Affitm logo',
    defaultMessage: 'Acima',
  },
  acimaButtonId: {
    id: 'AcimaButton.acimaButton.id',
    description: 'Id for Acima button',
    defaultMessage: 'acima-button',
  }
});
